import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import GUI from "../GUI";
import { TButtonProps } from "./Button";
import { UpdateEvent } from "../GUIEvents";

export type TToggleButtonProps = Omit<TButtonProps,"variant"|"value"|"onChange"> & {
    value?:boolean
    defaultValue?:boolean
    onUpdate?:(e:UpdateEvent<boolean, HTMLButtonElement>) => void

    // overrides
    onToggle:(current:boolean) => boolean
    iconChecked:JSX.Element
    iconUnchecked:JSX.Element
}
export interface IToggleButton {
    checked:boolean
}
export default forwardRef((props:TToggleButtonProps, ref?:ForwardedRef<IToggleButton>) => {
    const isManaged = props.hasOwnProperty("value")
    const [value,setValue] = useState<boolean>(props.value || props.defaultValue || false)
    const {value:_value,defaultValue,color,children,className,size,onClick,onUpdate,onToggle,iconChecked,iconUnchecked,...buttonProps} = props
    const selfRef = useRef<HTMLButtonElement|null>(null)
    const current = isManaged ? props.value! : value

    const _onClick = (e:React.MouseEvent<HTMLButtonElement>) => {
        if (isManaged) {
            const newValue = onToggle(props.value!)
            if (newValue!=props.value) {
                selfRef.current && onUpdate?.(new UpdateEvent(e.nativeEvent, newValue, selfRef.current))
            }
            return onClick?.(e)
        }else {
            setValue( value => {
                const newValue = onToggle(value)
                if (value!=newValue) {
                    selfRef.current && onUpdate?.(new UpdateEvent(e.nativeEvent, newValue, selfRef.current))
                }
                onClick?.(e)
                return newValue
            })
        }
    }
    useImperativeHandle(ref, () => ({
        get checked() { return current }
    }), [current])

    return <button className={GUI.joinClass("togglebutton", className)} {...buttonProps} onClick={_onClick} ref={selfRef}>
        {current ? iconChecked : iconUnchecked}
        {props.children}
    </button>
})